import React from "react";
import PropTypes from "prop-types";
const EditStaging = ({ payrollData }) => {
  return (
    <div className="row form-row">
      <div className="col-md-6 col-lg-6 col-sg-12 mb-3">
        <div className="form-group">
          <label className="form-label">Payroll Month</label>
          <input
            type="text"
            className="form-control"
            placeholder="Payroll Month"
            value={payrollData.payrollMonth}
            readOnly={true}
          />
        </div>
      </div>
    </div>
  );
};

EditStaging.propTypes = {
  payrollData: PropTypes.object.isRequired,
};

export default EditStaging;
